import './styles/GoogleFontViewer.scss';

import { CSSProperties, PropsWithChildren } from 'react';

import { useGoogleFonts } from '../../../../hooks';

interface Props extends PropsWithChildren {
  fontFamily: string;
  useAsVariableWrapper?: boolean;
}

interface Props extends PropsWithChildren {
  fontFamily: string;
  useAsVariableWrapper?: boolean;
}

const componentName = 'c-GoogleFontViewer';

export const GoogleFontViewer = ({
  fontFamily,
  children,
  useAsVariableWrapper = true,
}: Props) => {
  useGoogleFonts(fontFamily);

  if (useAsVariableWrapper) {
    return (
      <span
        className={componentName}
        style={{ '--gFontFamily': fontFamily } as CSSProperties}
      >
        {children}
      </span>
    );
  }

  return children;
};
